<template>
  <StoryblokComponent v-if="data?.story" :blok="data?.story.content" />
</template>
<script setup>
// The homepage brings its own header and footer (layouts/stage.vue)
definePageMeta({
  middleware: [to => {
    setPageLayout(['/', '/home'].includes(to.path) ? 'stage' : 'default')
  }]
})

const route = useRoute()
const { slug } = route.params
const url = slug && slug.length > 0 ? slug.join('/') : 'home'
const data = ref(null)

// Blocks that need the story itself (dates for news) inject it
provide('story', computed(() => data.value?.story))

const resolveRelations = ['SbEventPage.events']
const resolveLinks = ['events']

try {
  const slug = route.query?._storyblok || url.replace(/\/$/, '')
  data.value = await useHrStoryblok('cdn/stories/' + slug, { resolve_relations: resolveRelations, resolve_links: resolveLinks })
} catch (e) {
  if (e.status === 404) {
    navigateTo({ path: '/' }, { redirectCode: 301 })
  }
}
</script>
